module.exports = __webpack_public_path__ + "img/CCLF_infographic-05.c75462e2.png";